var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLectern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4701_1654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25005 12.75C2.12214 12.7501 1.99633 12.7175 1.88459 12.6552C1.77284 12.593 1.67887 12.5032 1.6116 12.3944C1.54433 12.2856 1.50601 12.1614 1.50027 12.0337C1.49453 11.9059 1.52156 11.7788 1.5788 11.6644L5.3288 4.16438C5.39115 4.03977 5.48698 3.935 5.60554 3.86181C5.72411 3.78862 5.86071 3.7499 6.00005 3.75H18C18.1394 3.7499 18.276 3.78862 18.3946 3.86181C18.5131 3.935 18.6089 4.03977 18.6713 4.16438L22.4213 11.6644C22.4785 11.7788 22.5056 11.9059 22.4998 12.0337C22.4941 12.1614 22.4558 12.2856 22.3885 12.3944C22.3212 12.5032 22.2273 12.593 22.1155 12.6552C22.0038 12.7175 21.878 12.7501 21.75 12.75H2.25005Z",
    stroke: "#0F172B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.75H17.25",
    stroke: "#0F172B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75V20.25",
    stroke: "#0F172B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20.25H15",
    stroke: "#0F172B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4701_1654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLectern);
export default __webpack_public_path__ + "static/media/Lectern.63bbd1cff60d2cb0e8722af79d65aa7d.svg";
export { ForwardRef as ReactComponent };